export default __webpack_public_path__ + "5c28bf85e6d0a773fef2aa1f8489e879.jpg";